export class SelectElementV2<E> {
    value: string | number;
    label: string;
    element: E;

    constructor(value: string | number, label: string, element: E) {
        this.value = value;
        this.label = label;
        this.element = element;
    }
}